import { render, staticRenderFns } from "./VoidClaim.vue?vue&type=template&id=1b8be898"
import script from "./VoidClaim.vue?vue&type=script&lang=js"
export * from "./VoidClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports